import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { createStructuredSelector } from 'reselect';
import {
  selectCurrentUser,
  selectCurrentUserRole,
} from '../../redux/user/user.selector';

const PrivateRoute = (props) => {
  const {
    component: Component,
    currentUser,
    currentUserRole,
    checkUserSession,
    roles,
    ...rest
  } = props;

  const render = (props) => {
    if (!currentUser) {
      alert('Not Authorized!');
      return <Redirect to="/" />;
    }

    if (roles && roles.indexOf(currentUserRole) === -1) {
      alert('Not Authorized!');
      return <Redirect to="/" />;
    }

    return <Component {...props} />;
  };

  return <Route {...rest} render={render} />;
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  currentUserRole: selectCurrentUserRole,
});

export default connect(mapStateToProps)(PrivateRoute);
